import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputCustomField } from './InputCustomField.entity';

export class InputEMailTemplateGroup<T extends EMode = EMode.entity> {
  /** Alias: id */
  id?: string;
  /** Alias: name */
  name?: string;
  /** Alias: customFields */
  customFields?: InputCustomField<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<InputEMailTemplateGroup> = {
  id: {
    alias: 'id',
  },
  name: {
    alias: 'name',
  },
  customFields: {
    alias: 'customFields',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputEMailTemplateGroupEntityDefinition: EntitiyDefinition<InputEMailTemplateGroup> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputEMailTemplateGroup',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
